var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 638,
    height: 337,
    viewBox: "0 0 638 337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 -311H638M0 -299H638M0 -287H638M0 -275H638M0 -263H638M0 -251H638M0 -239H638M0 -227H638M0 -215H638M0 -203H638M0 -191H638M0 -179H638M0 -167H638M0 -155H638M0 -143H638M0 -131H638M0 -119H638M0 -107H638M0 -95H638M0 -83H638M0 -71H638M0 -59H638M0 -47H638M0 -35H638M0 -23H638M0 -11H638M0 1H638M0 13H638M0 25H638M0 37H638M0 49H638M0 61H638M0 73H638M0 85H638M0 97H638M0 109H638M0 121H638M0 133H638M0 145H638M0 157H638M0 169H638M0 181H638M0 193H638M0 205H638M0 217H638M0 229H638M0 241H638M0 253H638M0 265H638M0 277H638M0 289H638M0 301H638M0 313H638M0 325H638M0 337H638",
    stroke: "url(#paint0_linear_340_2902)",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_340_2902",
    x1: 319,
    y1: 2.00001,
    x2: 319,
    y2: 337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02FFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02FFFF",
    stopOpacity: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertBg);
export default __webpack_public_path__ + "static/media/alert_bg.acabd81cf8227c1674fa010b2bd47e78.svg";
export { ForwardRef as ReactComponent };